module.exports = __webpack_public_path__ + "img/thumbnail_AfricanCrestedPorcupine_j_normal.ca847285.png";